import axios from 'axios';
import toast from 'react-hot-toast';

const getDefaultBaseURL = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8000';
  }

  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return '';
};

const apiClient = axios.create({
  baseURL: getDefaultBaseURL(),
});

export const API_BASE_URL = apiClient.defaults.baseURL;

export const setAuthToken = (token) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
};

// Flag to prevent multiple session expired notifications
let sessionExpiredShown = false;

// Add response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if we're not on the login page and haven't shown the notification yet
      const isLoginPage = window.location.pathname === '/login';
      
      if (!isLoginPage && !sessionExpiredShown) {
        sessionExpiredShown = true;
        
        // Clear auth data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setAuthToken(null);
        
        // Show session expired notification
        toast.error('Your session has expired. Please log in again.', {
          duration: 5000,
          id: 'session-expired',
        });
        
        // Redirect to login after a short delay
        setTimeout(() => {
          window.location.href = '/login';
          sessionExpiredShown = false; // Reset flag after redirect
        }, 1000);
      }
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
